<!-- 设备管理-设备列表页面 -->
<template>
  <div class="config-container flex-valign">
    <!-- 顶部tab栏区域 -->
    <ioc-tab-group :option="calType" @change="handleChange"></ioc-tab-group>
    <!--底部区域 -->
    <visitor-area
      ref="treeConfig"
      :areaType="areaType"
    ></visitor-area>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic, Cache } from "$utils";
import { deviceTableOption } from "../const/deviceTable";
import visitorArea from "../components/visitorArea";
export default {
  components: {
    visitorArea,
  },
  data() {
    return {
      //摄像机分类方式
      type: {},
      calType: {
        column: [
          {
            label: "访客申请区域配置 ",
            prop: "visitor",
            id: "1",
          },
          {
            label: "车辆申请区域配置 ",
            prop: "car",
            id: "2",
          },
          {
            label: "车间通行区域配置 ",
            prop: "workshop",

            id: "3",
          },
          {
            label: "视频监控区域配置 ",
            prop: "video",
            id: "4",
          },
          {
            label: "保卫岗位配置 ",
            prop: "security",
            id: "5",
          },
          {
            label: "道闸控制区域配置 ",
            prop: "gate",
            id: "6",
          },
        ],
      },
      calMetOption: deviceTableOption(false, false),
      areaType: "",
    };
  },
  created() {
    this.type = this.calType.column[0];
    this.areaType = this.calType.column[0].id;
  },
  destroyed() {},
  methods: {
    // 切换tab选项卡
    handleChange(column) {
      this.type = column;
      this.areaType = column.id;
      this.$refs.treeConfig.getAreaTree(this.areaType);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.config-container {
  width: 100%;
  height: 100%;

  .default-theme * {
    outline: none !important;
  }
}
</style>

